import useSWR from 'swr'
import { ParticipantController } from '@/controllers'
import { config } from '@/config'
import { useMemo } from 'react'

export const PARTICIPANTS_KEY = config.api.endpoints.participant.list

export const useParticipants = () => {
  const {
    data,
    mutate,
    error: uncaughtError,
    isLoading,
    isValidating,
  } = useSWR(PARTICIPANTS_KEY, () => ParticipantController.list())
  const memoizedData = useMemo(() => {
    const participants = data?.result?.[1] || []
    const error = data?.result?.[0] || uncaughtError
    const activeParticipants = participants.filter((participant) => !participant.disabled)

    return { participants, activeParticipants, error }
  }, [data, uncaughtError])

  const revalidate = async () => {
    const response = await mutate()

    if (!response) {
      throw new Error('Failed to revalidate participants')
    }

    return response.result
  }

  return {
    ...memoizedData,
    isLoading,
    isValidating,
    revalidate,
  }
}
